import {
  ActionIcon,
  Button,
  Modal,
  Pagination,
  Select,
  Skeleton,
  Table,
  Badge,
  Text,
  TextInput,
} from "@mantine/core";
import React, { useEffect, useState } from "react";
import { apiWrapWithErrorWithData } from "../utilities/apiHelpers";
import {
  getAgreementTypesApi,
  getObStatusForAg,
  updateObStatus,
} from "../utilities/apis/agreements";
import { Eye, Plus, SortAscending, SortDescending } from "tabler-icons-react";
import { getPartyNames } from "../utilities/apis/parties";
import { getBussinessUnit } from "../utilities/apis/serviceProvider";
import { formatIndianNumber, getObStatusText } from "../utilities/utilities";
import RelatedAgreementModal from "./AgreementsManager/agreementRelatedModal";

import { IconEdit } from "@tabler/icons-react";
import { useSelector } from "react-redux";
import { selectUserData } from "../redux/selectors";
import { showNotification } from "@mantine/notifications";
import { getStatusColor, getStatusText } from "../utilities/enums";

const ObligationStatus = () => {
  const [agreements, setAgreeements] = useState([]);
  const [configs, setConfigs] = useState({
    loading: true,
    pageNumber: 1,
    pageSize: 10,
    count: 0,
  });
  const currentUser = useSelector(selectUserData) || {};
  const loginAs = currentUser.loginAs;
  const estampOption = [
    {
      label: "Yes",
      value: "Yes",
    },
    {
      label: "No",
      value: "No",
    },
  ];
  const [reload, setReload] = useState(false);
  const [filters, setFilters] = useState({});
  const [sortByOptions, setSortByOptions] = useState({
    key: "createdAt",
    value: "desc",
  });
  const handleKeyChange = (val) => {
    const newSortOption = { key: val, value: sortByOptions.value };
    setSortByOptions(newSortOption);
  };
  const toggleOrder = () => {
    const newSortOption = {
      key: sortByOptions.key,
      value: sortByOptions.value === "asc" ? "desc" : "asc",
    };
    setSortByOptions(newSortOption);
  };
  useEffect(() => {
    const getAgreements = async () => {
      const sortOption = { [sortByOptions.key]: sortByOptions.value };
      const response = await apiWrapWithErrorWithData(
        getObStatusForAg({
          pageNumber: configs.pageNumber,
          pageSize: configs.pageSize,
          filters: filters,
          sortBy: sortOption,
        }),
      );
      if (response.success) {
        setAgreeements(response.agreements);
        setConfigs({
          ...configs,
          loading: false,
          count: response.count,
        });
      }
    };
    getAgreements();
  }, [sortByOptions, configs.pageNumber, configs.pageSize, reload]);
  const [businessunitList, setbusinessunitList] = useState([]);
  const [parties, setParties] = useState(["secondparty"]);
  const [obStatusModal, setObStatusModal] = useState(false);
  const [obStatusId, setObStatusId] = useState(0);
  function handleCloseObModal() {
    setObStatusModal(false);
    setObStatusId(0);
  }
  const handleCloseModal = () => {
    // Set the showModal state to false when the modal is closed
    setShowModal(false);
  };
  const [showModalRelated, setShowModalRelated] = useState(false);
  const [relatedAgreementId, setRelatedAgreementId] = useState(null);
  const handlePlusClick = (id) => {
    setShowModalRelated(true);
    setRelatedAgreementId(id);
  };
  const handleCloseRelatedAgreementModal = () => {
    setShowModalRelated(false);
  };
  useEffect(() => {
    const fetchBusinessUnits = async () => {
      try {
        const { data } = await getBussinessUnit();
        if (data) {
          setbusinessunitList(data.businessunitList || []);
        } else {
          console.error("Invalid business unit response format:", response);
        }
      } catch (error) {
        console.error("Error fetching business units:", error);
      }
    };
    const getPartyName = async () => {
      const response = await apiWrapWithErrorWithData(getPartyNames());
      if (response.success) {
        setParties(response.parties);
      }
    };
    getPartyName();
    fetchBusinessUnits();
  }, []);
  const [agreementTypeOptions, setAgreementTypeOptions] = useState([]);
  const [transformedData, settransformedData] = useState([]);
  const getAgreementTypes = async () => {
    const resp = await apiWrapWithErrorWithData(getAgreementTypesApi());
    if (resp?.success && resp?.typesOfAgreement) {
      const uniqueValues = Array.from(new Set([...resp.typesOfAgreement]));
      const temp = uniqueValues.map((item) => ({ label: item, value: item }));
      setAgreementTypeOptions([...agreementTypeOptions, ...temp]);
    }
  };
  useEffect(() => {
    getAgreementTypes();
  }, []);
  useEffect(() => {
    if (businessunitList.length > 0) {
      settransformedData(
        businessunitList.map((unit) => ({
          value: unit.id + "",
          label: unit.name,
        })),
      );
    }
  }, [businessunitList]);
  const onViewClick = (agreementId) => {
    const url = `/app/agreements_manager/agreements/details/${agreementId}`;
    window.open(url, "_blank"); // '_blank' specifically tells the browser to open in a new tab/window
  };

  const handleNotRequired = async (req, res) => {
    const response = await apiWrapWithErrorWithData(
      updateObStatus({
        agreementId: obStatusId,
        obStatus: "not required",
      }),
    );
    if (response.success) {
      setObStatusId(0);
      setObStatusModal(false);
      showNotification({
        color: "green",
        title: "update obligation status",
        message: "obligation status updated",
      });
      setReload(!reload);
    }
  };
  return (
    <div>
      {showModalRelated && (
        <Modal
          overflow="inside"
          opened
          onClose={handleCloseRelatedAgreementModal} // Call the handler on modal close
          size="calc(80vw)"
        >
          <RelatedAgreementModal agreementId={relatedAgreementId} />
        </Modal>
      )}
      <Modal opened={obStatusModal} onClose={handleCloseObModal}>
        <div>
          <Text>
            are you sure there are no obligations required for this agreement
          </Text>
          <div className="flex justify-between mt-4">
            <Button onClick={handleCloseObModal}>cancel</Button>
            <Button color="yellow" onClick={handleNotRequired}>
              not required
            </Button>
          </div>
        </div>
      </Modal>
      <Text
        style={{
          fontSize: "22px",
          fontWeight: "600",
          letterSpacing: "1px",
          textTransform: "lowercase",
          fontFamily: "Lexend",
          whiteSpace: "nowrap",
          paddingBottom: "13px",
          position: "relative",
          color: "black",
          // margin: "0 auto"
        }}
      >
        obligations status
      </Text>

      {configs.loading && (
        <div className="flex flex-col">
          {Array.from({ length: 10 }).map((i) => (
            <Skeleton key={i} height={30} radius="md" className="my-1 w-full" />
          ))}
          <div className="flex flex-row justify-center">
            <Skeleton height={40} radius="md" className="w-40" />
          </div>
        </div>
      )}
      {!configs.loading && agreements && (
        <>
          <div className="flex w-full justify-between items-center">
            <div className="flex flex-col">
              <div className="flex flex-row-sm">
                {/* <Text size="xs" className="mb-2" color="gray">
                    Case sensitive search
                  </Text> */}
                <div className="flex items-center">
                  {/* <TextInput
                      value={listing.searchString}
                      onChange={(input) => {
                        const val = getValueForInput(input);
                        setListing((prevState) => ({
                          ...prevState,
                          searchString: val,
                        }));
                      }}
                      placeholder="Type to search..."
                      icon={<Search size={14} />}
                    /> */}

                  {/* <Select
                    className="mx-2"
                    placeholder="estamp"
                    value={filters.estamp || null}
                    onChange={(val) => {
                      setFilters((prevState) => ({
                        ...prevState,
                        estamp: val,
                      }));
                    }}
                    data={estampOption}
                    style={{ minWidth: "228px" }}
                  /> */}
                  <Select
                    className="mx-2"
                    placeholder="select obligation status"
                    value={filters.obligationStatus || null}
                    onChange={(val) => {
                      setFilters((prevState) => ({
                        ...prevState,
                        obligationStatus: val,
                      }));
                    }}
                    data={[
                      { label: "pending", value: "NA" },
                      { label: "created", value: "created" },
                      { label: "not required", value: "not required" },
                    ]}
                    style={{ minWidth: "228px" }}
                  />
                  <Select
                    className="mx-2"
                    placeholder="select business unit"
                    value={filters.mapBusinessunit || null}
                    data={transformedData}
                    onChange={(value) => {
                      setFilters((prevState) => ({
                        ...prevState,
                        mapBusinessunit: value,
                      }));
                    }}
                    style={{ minWidth: "228px" }}
                  />
                  <TextInput
                    className="mx-2"
                    placeholder="type job order"
                    value={filters?.jobOrder?.contains || null}
                    onChange={(e) =>
                      setFilters((preState) => ({
                        ...preState,
                        jobOrder: { contains: e.target.value },
                      }))
                    }
                    maw={400}
                    mx="auto"
                    style={{ minWidth: "228px" }}
                  />
                  <Select
                    className="mx-2"
                    // value={filters.partyName || null}
                    onChange={(value) => {
                      // const val = getValueForInput(input);
                      setFilters((prevState) => ({
                        ...prevState,
                        OR: [
                          {
                            secondParty: {
                              path: "$.name",
                              string_contains: value,
                              // mode: "insensitive",
                            },
                          },
                          {
                            secondParty: {
                              path: "$.brandName",
                              string_contains: value,
                            },
                          },
                        ],
                      }));
                    }}
                    placeholder="party name"
                    type="text"
                    searchable
                    data={parties}
                    style={{ minWidth: "228px" }}
                  />
                </div>
              </div>
            </div>
          </div>
          <br />
        </>
      )}
      <Button className="mx-2" color="green" onClick={() => setReload(!reload)}>
        search
      </Button>
      <Button
        className="mx-2"
        color="red"
        onClick={() => {
          // setFilters({}), setReload(!reload);
          window.location.reload();
        }}
      >
        clear
      </Button>
      {/* <div className="flex float-right">
        <div className="flex">
          <Select
            value={sortByOptions.key}
            onChange={(val) => handleKeyChange(val)}
            data={[
              { label: "created at", value: "createdAt" },
              { label: "end date", value: "dueDateOfContract" },
              { label: "type of agreement", value: "typeOfAgreement" },
              { label: "ain", value: "id" },
              { label: "agreement value", value: "agreementValue" },
            ]}
          />
          <ActionIcon className="mx-2" onClick={toggleOrder}>
            {sortByOptions.value === "asc" ? (
              <SortAscending size={32} />
            ) : (
              <SortDescending size={32} />
            )}
          </ActionIcon>
        </div>
      </div> */}

      {!configs.loading && agreements && (
        <div className="flex flex-col">
          <Table striped>
            <thead>
              <tr>
                {/* <th>sr no.</th> */}
                <th>ain</th>
                <th>type</th>
                <th>job order</th>
                <th>agreement value</th>
                <th>second party</th>
                <th>status</th>
                <th>start date</th>
                <th>obligation status</th>
                <th>&nbsp;</th>
                <th>&nbsp;</th>
                {loginAs.id === 4 && <th>&nbsp;</th>}
              </tr>
            </thead>
            <tbody>
              {agreements.map((row) => (
                <tr key={row.id}>
                  {/* <td>{serialNumber++}</td> */}
                  <td>{row.id}</td>
                  <td>{row.agreementData.json.typeOfAgreement}</td>
                  <td>{row.jobOrder}</td>
                  <td>{formatIndianNumber(row.agreementValue)}</td>
                  <td>
                    {row.agreementData.json.brandName}
                    <br />
                    <span className="font-light">{`(${
                      row.agreementData?.json?.secondParty?.name || "-"
                    })`}</span>
                  </td>

                  <td>
                    <Badge color={getStatusColor(row.status)}>
                      {" "}
                      {getStatusText(row.status)}{" "}
                    </Badge>
                  </td>
                  <td>{row.contractStartDate?.slice(0, 10) || "-"}</td>
                  <td>
                    <Badge color={getObStatusText(row.obligationStatus).color}>
                      {getObStatusText(row.obligationStatus).text}{" "}
                    </Badge>
                  </td>
                  <td style={{ textAlign: "center" }}>
                    {row.relationshipWith ? (
                      <div className="flex flex-row ">
                        <ActionIcon
                          onClick={() => {
                            handlePlusClick(row.id);
                          }}
                          color="white"
                        >
                          <Plus color="#46BDE1" size={24} />
                        </ActionIcon>
                        {/* )} */}
                      </div>
                    ) : (
                      <span className="mr-2">{"--"}</span>
                    )}
                  </td>
                  <td>
                    <div className="flex flex-row mr-4">
                      <ActionIcon
                        onClick={() => {
                          onViewClick(row.id);
                        }}
                        color="white"
                      >
                        <Eye color="#46BDE1" size={24} />
                      </ActionIcon>
                      {/* )} */}
                    </div>
                  </td>
                  {loginAs.id === 4 && (
                    <td>
                      <ActionIcon
                        disabled={row.obligationStatus !== "NA"}
                        onClick={() => {
                          setObStatusId(row.id);
                          setObStatusModal(true);
                        }}
                      >
                        <IconEdit color="#46BDE1" size={24} />
                      </ActionIcon>
                    </td>
                  )}
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      )}
      {!configs.loading && !agreements?.length ? (
        <div
          className="flex justify-center items-center"
          style={{
            minHeight: "300px",
          }}
        >
          No agreements
        </div>
      ) : null}
      {/* </div> */}
      {!configs.loading && configs.count ? (
        <div className="flex flex-row justify-center my-4">
          <Pagination
            page={configs.pageNumber}
            onChange={(page) => {
              setConfigs({
                ...configs,
                pageNumber: page,
              });
            }}
            total={Math.ceil(configs.count / configs.pageSize)}
          />
          <Text className="mx-4">select page size</Text>
          <Select
            className="w-20"
            data={["10", "20", "50"]}
            value={configs.pageSize + ""}
            onChange={(val) =>
              setConfigs({ ...configs, pageSize: parseInt(val) })
            }
          />
        </div>
      ) : null}
    </div>
  );
};

export default ObligationStatus;
